import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy',
  standalone: true,
})
export class GroupByPipe implements PipeTransform {
  private recentlyUpdatedGroups: string[] = [];

  transform(value: any[], key: string): any {
    if (!value || !key) return value;

    // Group by the specified key
    const grouped = value.reduce((acc, currentItem) => {
      const groupKey = currentItem[key];
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(currentItem);

      // Track the recently updated group by moving it to the front
      const index = this.recentlyUpdatedGroups.indexOf(groupKey);
      if (index > -1) {
        this.recentlyUpdatedGroups.splice(index, 1); // Remove existing entry
      }
      this.recentlyUpdatedGroups.unshift(groupKey); // Add to the front

      return acc;
    }, {});

    // Reorder the groups based on recently updated order
    const orderedGroups = {};
    this.recentlyUpdatedGroups.forEach((groupKey) => {
      if (grouped[groupKey]) {
        orderedGroups[groupKey] = grouped[groupKey];
      }
    });

    return orderedGroups;
  }
}
